import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { IUserShort } from "../../../interfaces/interfaces";
import { TextPlain, TitleH3, TitleH4 } from "../../../components/generic";
import { DateLine } from "../../ProfileUser/SimpleComponents";
import { getDateOrNone, isoDate } from "../../../utils/helpers";
import { OverviewInfoContainer } from "../../../components/containers";
import { useCalendar } from "../../../components/Calendar";
import {
  GraduateIcon,
  SendIcon
} from "../../../components/Icons/studentOverview";

import { InfoWithIconWrapper } from "../styles";
import { FlagIcon } from "../../../components/Icons/Flags";

export const AboutStay: FC<{ data: Partial<IUserShort>; children?: never }> = ({
  data: {
    preferred_move_in,
    preferred_move_out,
    search_location_string,
    propose,
    past_experience
  }
}) => {
  const moveInDate = useCalendar({
    value: getDateOrNone(preferred_move_in)
  });
  const moveOutDate = useCalendar({
    value: getDateOrNone(preferred_move_out)
  });
  const { t } = useTranslation("matches");

  return (
    <OverviewInfoContainer>
      <TitleH3
        m="0 0 1rem"
        color="hardGray"
        fontSize="sizeTitle"
        lineHeight="2rem"
      >
        {t(`host.userInfo.aboutStay`)}
      </TitleH3>
      {typeof search_location_string === "string" &&
        search_location_string.length > 0 && (
          <>
            <TitleH4 m="0 0 0.5rem" fW="weightMedium" c="hardGray">
              {t(`host.userInfo.goTo`)}
            </TitleH4>
            <InfoWithIconWrapper margin="0 0 1rem" isCentered>
              <FlagIcon
                // search_location_string if exists is unformatted Google Maps AutocompletePrediction description string
                countryName={search_location_string.substring(
                  search_location_string.indexOf(", ") + 1
                )}
                margin="0 0.5rem 0 0"
              />
              <TextPlain color="hardGray">{search_location_string}</TextPlain>
            </InfoWithIconWrapper>
          </>
        )}
      <TitleH4 m="0 0 0.5rem" fW="weightMedium" c="hardGray">
        {t(`host.userInfo.preferredDates`)}
      </TitleH4>
      <InfoWithIconWrapper margin="0 0 1rem">
        <DateLine
          start={isoDate(moveInDate.value)}
          end={isoDate(moveOutDate.value)}
          ico
          context="profileOverview"
          c="hardGray"
        />
      </InfoWithIconWrapper>
      {propose && propose.length > 0 && (
        <>
          <TitleH4 m="0 0 0.5rem" fW="weightMedium" c="hardGray">
            {t(`host.userInfo.propose.title`)}
          </TitleH4>
          <InfoWithIconWrapper margin="0 0 1rem">
            <GraduateIcon />
            <p>
              {propose.map((item, idx) => (
                <span key={item}>
                  {t(`host.userInfo.propose.options.${item}`)}
                  {idx !== propose!.length - 1 && propose!.length > 1 && " & "}
                </span>
              ))}
            </p>
          </InfoWithIconWrapper>
        </>
      )}
      {past_experience && past_experience.length > 0 && (
        <>
          <TitleH4 m="0 0 0.5rem" fW="weightMedium" c="hardGray">
            {t(`host.userInfo.pastExperience.title`)}
          </TitleH4>
          <InfoWithIconWrapper isCentered>
            <SendIcon />
            <p>
              {past_experience.map((item, idx) => (
                <span key={item}>
                  {" "}
                  {idx === past_experience!.length - 1 &&
                    past_experience!.length > 1 &&
                    t(`host.userInfo.and`)}{" "}
                  {t(`host.userInfo.pastExperience.options.${item}`)}
                  {idx < past_experience!.length - 2 &&
                    past_experience!.length > 2 &&
                    ", "}
                </span>
              ))}
            </p>
          </InfoWithIconWrapper>
        </>
      )}
    </OverviewInfoContainer>
  );
};
